'use client';

import { RewardCarousel } from './RewardCarousel';
import { RewardImage } from './RewardImage';
import {
  CmsOffer,
  ComponentFlexibleHeroBlock,
  EnumFlexibleHeroBlockRewardType,
  EnumFlexibleHeroBlockTheme,
} from '$/(cms)/_modules/cmsService/types';

type RewardContentProps = {
  rewardType?: EnumFlexibleHeroBlockRewardType;
  offers?: CmsOffer[];
  imageDesktop: ComponentFlexibleHeroBlock['imageDesktop'];
  imageMobile: ComponentFlexibleHeroBlock['imageMobile'];
  theme?: EnumFlexibleHeroBlockTheme;
  lang: string;
  headline?: string;
};

export const RewardContent = ({
  rewardType,
  offers,
  imageDesktop,
  imageMobile,
  lang,
  headline,
  theme,
}: RewardContentProps): JSX.Element | null => {
  switch (rewardType) {
    case EnumFlexibleHeroBlockRewardType.Carousel:
      return <RewardCarousel offers={offers ?? []} lang={lang} theme={theme} />;
    case EnumFlexibleHeroBlockRewardType.Image:
      return (
        <RewardImage
          imageDesktop={imageDesktop}
          imageMobile={imageMobile}
          headline={headline}
        />
      );
    default:
      return null;
  }
};
